const fullDateStyleFormatter = new Intl.DateTimeFormat('es-CL', {
  dateStyle: 'full',
});

export {
  fullDateStyleFormatter, //
};
